import { VIRTUAL_SPORTS_FEED_LOBBY_CATEGORY_ID } from '../../constants';
import { useVirtualSportsStore } from '../../store';
import { IVirtualSportsGame } from '../../types';
import SportsGrid from './components/SportsGrid';

const SportsLobby = () => {
  const { feed, isLoaded } = useVirtualSportsStore(['feed', 'isLoaded']);
  const { categories, games } = feed;

  const feedLobbyCategory =
    // @ts-expect-error TODO: move useVirtualSportsStore to TypeScript
    categories.data[VIRTUAL_SPORTS_FEED_LOBBY_CATEGORY_ID];

  const sports: IVirtualSportsGame[] =
    feedLobbyCategory?.games
      // @ts-expect-error TODO: move useVirtualSportsStore to TypeScript
      ?.map((gameId: string) => games.data?.[gameId])
      .filter(Boolean) || [];

  return <SportsGrid sports={sports} isLoaded={isLoaded && games.isLoaded} />;
};

export default SportsLobby;
